/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RadioButtonsDisplayFormat {
    BUTTON_STRIP = 'ButtonStrip',
    NORMAL = 'Normal',
}
